const fb = require('../../firebaseConfig.js')
export default {
  data () {
    return {
      needRegister: false,
      loginForm: {
        email: '',
        password: ''
      },
      registerForm: {
        email: '',
        password: '',
        password2: ''
      },
      email: '',
      password: '',
      passwordDifferent: false,
      missingMail: false,
      errorRegisterMessage: '',
      errorRegister: false
    }
  },
  methods: {
    /**
     * Function to login
     */
    login () {
      fb.auth.signInWithEmailAndPassword(this.loginForm.email, this.loginForm.password).then(user => {
        this.$store.commit('setCurrentUser', user.user)
        this.$router.push('/home')
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     * Function to register
     */
    register () {
      this.passwordDifferent = false
      this.missingMail = false
      this.errorRegister = false
      if (this.registerForm.password === this.registerForm.password2) {
        if (this.registerForm.email) {
          fb.auth.createUserWithEmailAndPassword(this.registerForm.email, this.registerForm.password).then(user => {
            console.log(user)
            fb.auth.signInWithEmailAndPassword(this.registerForm.email, this.registerForm.password).then(user => {
              this.$store.commit('setCurrentUser', user.user)
              // Add the user in the users collection
              console.log('User saved')
              this.$router.push('/profile')
            }).catch(err => {
              console.log(err)
            })
          }).catch(error => {
            this.errorRegister = true
            this.errorRegisterMessage = error.message
            console.log(error.message)
          })
        } else {
          console.log('Adresse mail manquante')
          this.missingMail = true
        }
      } else {
        console.log('Les mots de passes doivent être identidiques')
        this.passwordDifferent = true
      }
    },
    showRegister () {
      this.needRegister = true
    },
    showLogin () {
      this.needRegister = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/login/login.js